enum calculationTypeVariant {
  BR182025 = "BR182025",
}

export default calculationTypeVariant;
